<template>
	<li class="express-type-freight clearfix" >
		<div class="type">
			<div class="ui-ico-sfi" :class="{'icon-overdue-refund': rateInfo.limitTypeCode === 'T104' || rateInfo.limitTypeCode === 'T801'}">
				{{productName}}
				<em v-if="rateInfo.distanceTypeCode ==='R10202'" style="color:red;">({{_.ll('郊')}})</em>
			</div>
			<span class="icon-sf-cost-lower" v-if="rateInfo.regionFreight !== 0">
				<span class="icon-path1"></span><span class="icon-path2"></span><span class="icon-path3"></span>
			</span>
		</div>
		<div class="type">
			<!--寄付价-->
			<p class="hard" v-if="showDeliverFreight || !rateInfo.destWeightUnit">{{rateInfo.weight+rateInfo.weightUnit}}</p>
			<!--到付价-->
			<p class="hard" v-else>{{rateInfo.destWeight+rateInfo.destWeightUnit}}</p>
		</div>
		<div class="type" v-if="rateInfo.addTime && rateInfo.deliverTime && rateInfo.addTime != rateInfo.deliverTime">
			<p class="hard">{{rateInfo.addTime}}<br/>{{_ll('偏远区域加时0.5工作日')}}</p>
		</div>
		<div class="type" v-if="rateInfo.addTime && rateInfo.deliverTime && rateInfo.addTime === rateInfo.deliverTime &&
		 '2' === rateInfo.destView && '2'=== rateInfo.orgionView">
			<p class="hard">{{rateInfo.addTime}}{{_ll('工作日')}}</p>
		</div>
		<div class="type" v-if="rateInfo.addTime && rateInfo.deliverTime && rateInfo.addTime === rateInfo.deliverTime &&
		 ('2' !== rateInfo.destView || '2' !== rateInfo.orgionView)">
			<p class="hard">{{/^(\d{4})-(\d{2})-(\d{2})(\s*)(\d{2}):(\d{2})$/.test(rateInfo.deliverTime) ?
				(rateInfo.deliverTime+'前'):rateInfo.deliverTime}}</p>
		</div>
		<div class="type" v-if="!rateInfo.addTime && rateInfo.deliverTime && '2' === rateInfo.destView && '2'=== rateInfo.orgionView">
			<p class="hard">{{rateInfo.addTime}}{{_ll('工作日')}}</p>
		</div>
		<div class="type"
			 v-if="!rateInfo.addTime && rateInfo.deliverTime && ('2' !== rateInfo.destView || '2' !== rateInfo.orgionView)">
			<p class="hard">{{/^(\d{4})-(\d{2})-(\d{2})(\s*)(\d{2}):(\d{2})$/.test(rateInfo.deliverTime) ?
				(rateInfo.deliverTime+'前'):rateInfo.deliverTime}}</p>
		</div>
		<div class="type" v-if="!rateInfo.deliverTime"><p class="hard">{{_ll('已过最晚收件时间')}}</p></div>
		<div class="type">
			<!--寄付价-->
			<p class="hot" v-if="showDeliverFreight">{{((rateInfo.orgionView === "1" && rateInfo.destView !== "3") ||
				(rateInfo.orgionView === "2" && rateInfo.destView === "1")) ?
				rateInfo.totalFreight + (rateInfo.currencyName === "人民币" ? "元" : rateInfo.currencyName) :
				(rateInfo.freight+rateInfo.fuelCost) + (rateInfo.currencyName === "人民币" ? "元" : rateInfo.currencyName)}}</p>
			<!--到付价-->
			<p class="hot" v-else>{{rateInfo.orgionView === "1" && rateInfo.destView === "1" ?
				rateInfo.totalFreight + (rateInfo.destCurrencyName === "人民币" ? "元" : rateInfo.destCurrencyName) :
				(rateInfo.destFreight+rateInfo.destFuelCost) + (rateInfo.destCurrencyName === "人民币" ? "元" : rateInfo.destCurrencyName)}}</p>
		</div>
	</li>
</template>

<script>
    export default {
        name: "PayFeeDomestic",
		data () {
        	return {

			}
		},
		props: {
			showDeliverFreight: {
				type: Boolean,
				defaultValue: true
			},
			rateInfo: {
				addTime: String,
				cargoTypeCode: String,
				cargoTypeName: String,
				currencyName: String,
				deliverTime: String,
				destCurrencyName: String,
				destDistributionFreight: Number,
				destFreight: Number,
				destFuelCost: Number,
				destFuelFlg: Boolean,
				destPickupFreight: Number,
				destTransportFreight: Number,
				destView: String,
				destWeight: Number,
				destWeightUnit: String,
				distanceTypeCode: String,
				distanceTypeName: String,
				distributionFreight: Number,
				expectArriveTm: String,
				expressTypeCode: String,
				freight: Number,
				fuelCost: Number,
				internet: Boolean,
				limitTypeCode: String,
				limitTypeName: String,
				orgionView: String,
				otherService: String,
				pickupFreight: Number,
				productCode: String,
				regionFreight: Number,
				totalFreight: Number,
				transportFreight: Number,
				weight: Number,
				weightUnit: String
			}
		},
		computed: {
			isShowCargoType: function () {
				return !(this.rateInfo.orgionView === '1' && (this.rateInfo.destView === '1'
					|| this.rateInfo.destView === '2'))
			},
			productName: function () {
				if (this.rateInfo.cargoTypeName) {
					return this.isShowCargoType ? this.rateInfo.limitTypeName +
						'(' + this.rateInfo.cargoTypeName + ')' : this.rateInfo.limitTypeName
				} else {
					return this.rateInfo.limitTypeName
				}
			}
		}
    }
</script>

<style scoped>
	.icon-sf-cost-lower .icon-path1:before {
		color: rgb(233, 36, 6);
	}
	.icon-sf-cost-lower .icon-path2:before {
		margin-left: -1em;
		color: rgb(255, 255, 255);
	}
	.icon-sf-cost-lower .icon-path3:before {
		margin-left: -1em;
		color: rgb(219, 29, 49);
	}
	.icon-sf-cost-lower{
		font-size: 20px;
		vertical-align: middle;
		position: relative;
		bottom: 4px;
	}
	.icon-overdue-refund:after {
		font-size: 24px;
		top: -5px;
		color: #ec2200;
	}
	.clearfix {
		zoom: 1;
	}
	li:first-child {
		border-top: 0;
	}
	li {
		list-style: none;
		background-color: #fff;
		border-bottom: #ddd 1px solid;
	}
	.type {
		display: inline-block;
		float: left;
		color: #333;
		word-break: break-all;
	}
	.express-type-freight{
		padding: 10px;
		overflow: hidden;
	}
	.express-type-freight .type:nth-of-type(1) {
		width: 30%;
	}
	.express-type-freight .type:nth-of-type(2) {
		width: 20%;
	}
	.express-type-freight .type:nth-of-type(3) {
		width: 30%;
	}
	.ui-ico-sfi {
		display: inline-block;
		background-repeat: no-repeat;
		vertical-align: middle;
	}
	.hard {
		color: #333;
	}
	.hot {
		color: #ed2210;
	}

</style>



// WEBPACK FOOTER //
// src/pages/payFee/pay-fee-domestic.vue